<template>
    <v-btn v-if="allowCopyPaste" :icon="mode === 'icon'" :class="cssClass" @click="copyToClipboard">
        <v-icon>{{icons.mdiContentCopy}}</v-icon>
        <template v-if="mode !== 'icon'">
            <mrx-translation :token="translationToken"></mrx-translation>
        </template>
    </v-btn>
    <div v-else>
    </div>
</template>

<script>
import { copyToClipboard as copyToClipboardUtil } from '../../utils/copyUtils';
import icons from '@/mixins/icons';
import { mapGetters } from 'vuex'

export default {
    name: 'CopyClipboardButton',
    mixins: [icons],
    props: {
        mode: {
            type: String,
            required: true,
            validator: value => ['button', 'icon'].includes(value),
        },
        cssClass: {
            type: String,
            default: '',
        },
        token: {
            type: String,
            required: true,
            default: 'app.button.copy.title',
        },
        name: {
            type: String,
            required: true,
        },
        payload: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isCopied: false,
        };
    },
    computed: {
        translationToken() {
            return this.isCopied ? 'app.button.copy.action' : this.token;
        },
        allowCopyPaste() {
            const value = this.$store.state.settings.engagements_features.allowCopyPaste;
            return value;
        }
    },
    methods: {
        copyToClipboard() {
            copyToClipboardUtil(this.payload, () => {
                if (this.mode === 'button') {
                    this.isCopied = true;
                    setTimeout(() => {
                        this.isCopied = false;
                    }, 2000);
                }
            });
            this.$track(this.$analyticsEvents.COPY_BUTTON, { name: this.name });
        },
    },
};
</script>
